import type { QueryClient } from "@tanstack/react-query";
import { achievementsQueryOptions } from "../queries/useGetAchievements";
import { enterpriseOverviewQueryOptions } from "../queries/useGetEnterpriseOverview";
import { facilityMaturityEventsQueryOptions } from "../queries/useGetFacilityMaturityEvents";
import { healthScoreQueryOptions } from "../queries/useGetHealthScore";
import { itemsOfConcernQueryOptions } from "../queries/useGetItemsOfConcern";
import { recentWinsQueryOptions } from "../queries/useGetRecentWins";

/** Loader prefetch for facility side sheet (portfolio check + maturity/value deps). */
export async function prefetchFacilityDetailQueries(
  queryClient: QueryClient,
  customerId: number,
  facilityId: number,
): Promise<boolean> {
  const overview = await queryClient.ensureQueryData(
    enterpriseOverviewQueryOptions(customerId),
  );

  const inPortfolio = overview.facilities.some(
    (f) => f.facilityId === facilityId,
  );
  if (!inPortfolio) {
    return false;
  }

  await Promise.all([
    queryClient.ensureQueryData(healthScoreQueryOptions(customerId)),
    queryClient.ensureQueryData(
      facilityMaturityEventsQueryOptions(customerId, facilityId),
    ),
    queryClient.ensureQueryData(recentWinsQueryOptions(customerId)),
    queryClient.ensureQueryData(itemsOfConcernQueryOptions(customerId)),
    queryClient.ensureQueryData(achievementsQueryOptions(customerId)),
  ]);

  return true;
}
